import "@arco-design/web-react/es/Typography/style";
import _Typography from "@arco-design/web-react/es/Typography";
import "@arco-design/web-react/es/Trigger/style";
import _Trigger from "@arco-design/web-react/es/Trigger";
import React from 'react';
import { SketchPicker } from 'react-color';
import { generate, getRgbStr } from '@arco-design/color';
import { useSelector, useDispatch } from 'react-redux';
import useLocale from '@/utils/useLocale';
import styles from './style/color-panel.module.less';

function ColorPanel() {
  const theme = document.querySelector('body').getAttribute('arco-theme') || 'light';
  const settings = useSelector(state => state.settings);
  const locale = useLocale();
  const themeColor = settings.themeColor;
  const list = generate(themeColor, {
    list: true
  });
  const dispatch = useDispatch();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Trigger, {
    trigger: "hover",
    position: "bl",
    popup: () => /*#__PURE__*/React.createElement(SketchPicker, {
      color: themeColor,
      onChangeComplete: color => {
        const newColor = color.hex;
        dispatch({
          type: 'update-settings',
          payload: {
            settings: { ...settings,
              themeColor: newColor
            }
          }
        });
        const newList = generate(newColor, {
          list: true,
          dark: theme === 'dark'
        });
        newList.forEach((l, index) => {
          const rgbStr = getRgbStr(l);
          document.body.style.setProperty(`--arcoblue-${index + 1}`, rgbStr);
        });
      }
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.input
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.color,
    style: {
      backgroundColor: themeColor
    }
  }), /*#__PURE__*/React.createElement("span", null, themeColor))), /*#__PURE__*/React.createElement("ul", {
    className: styles.ul
  }, list.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: styles.li,
    style: {
      backgroundColor: item
    }
  }))), /*#__PURE__*/React.createElement(_Typography.Paragraph, {
    style: {
      fontSize: 12
    }
  }, locale['settings.color.tooltip']));
}

export default ColorPanel;